import { Link } from "react-router-dom";
import { Linkedin, Instagram } from "lucide-react";

const COLS = [
  {
    title: "Platform",
    links: [
      { label: "Overview", to: "/platform" },
      { label: "Manage", to: "/platform#manage" },
      { label: "Maintain", to: "/platform#maintain" },
      { label: "Understand", to: "/platform#understand" },
      { label: "Optimize", to: "/platform#optimize" },
      { label: "ANFORD Insights", to: "/insights" },
    ],
  },
  {
    title: "Solutions",
    links: [
      { label: "Institutional Owners", to: "/solutions" },
      { label: "Property Managers", to: "/solutions" },
      { label: "Commercial", to: "/solutions" },
      { label: "Residential", to: "/solutions" },
      { label: "Plans", to: "/plans" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/company" },
      { label: "Blog", to: "/blog" },
      { label: "FAQ", to: "/faq" },
      { label: "Contact", to: "/demo" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Service", to: "/terms" },
      { label: "Cookie Policy", to: "/cookies" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-navy/10 bg-white">
      <div className="container-x py-12 md:py-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-6 md:gap-10">
          <div className="col-span-2">
            <img src="/assets/anford-logo.png" alt="ANFORD" className="h-10 w-auto" loading="lazy" width="120" height="40" />
            <p className="mt-5 font-display text-sm font-bold tracking-[0.18em] text-gold">MANAGE. PROTECT. GROW.</p>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate2">
              Property management, powered by intelligence. Built for African real estate.
            </p>
            <div className="mt-6 flex gap-3">
              <a href="#" data-testid="footer-linkedin-link" onClick={(e) => e.preventDefault()} aria-label="LinkedIn (coming soon)" className="flex h-10 w-10 items-center justify-center rounded-full border border-navy/15 text-navy transition-colors hover:border-gold hover:text-gold">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="#" data-testid="footer-instagram-link" onClick={(e) => e.preventDefault()} aria-label="Instagram (coming soon)" className="flex h-10 w-10 items-center justify-center rounded-full border border-navy/15 text-navy transition-colors hover:border-gold hover:text-gold">
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <p className="font-display text-sm font-bold uppercase tracking-wider text-navy-ink">{col.title}</p>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="text-sm text-slate2 transition-colors hover:text-navy">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-navy/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-slate2" data-testid="footer-copyright">© 2026 ANFORD. All rights reserved.</p>
          <p className="text-sm text-slate2">Property Management. Powered by Intelligence.</p>
        </div>
      </div>
    </footer>
  );
}
